module.exports = __webpack_public_path__ + "img/acc20bf.svg";